import axiosInstance from 'src/utils/axios';

import { zerreactorBackendEndpoints } from 'src/api/services/zerreactor_backend_definition/zerreactorBackendEndpoints';

export const authService = {
    changeOrganization: async (organizationId, accessToken) => {
        const response = await axiosInstance.post(
            zerreactorBackendEndpoints.Auth.changeOrganization(organizationId),
            {},
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
        );
        
        // Return the full response to handle the new format in the calling component
        return response;
    }
};